module.exports = "/_next/static/images/Alteb-bd2d223504ce871f9df386531a2e96e2.svg";